
import React from 'react';

function Kids() {
  return (
    <div>
      <h1>Kids Page</h1>
    </div>
  );
}

export default Kids;
